"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function ToolsSettingsTab({ selected, icon, children, onClick, }) {
    return ((0, jsx_runtime_1.jsx)(Tab, { selected: selected, onClick: onClick, role: "tab", "aria-label": "tab", "data-e2e": 'ToolsSettingsTab_Tab', children: (0, jsx_runtime_1.jsxs)(StyledPushInAnimation, { delay: 200, className: "PushInAnimation", "data-e2e": 'ToolsSettingsTab_StyledPushInAnimation', children: [(0, jsx_runtime_1.jsx)(TabIcon, { name: icon, "data-e2e": 'ToolsSettingsTab_TabIcon' }), children] }) }));
}
exports.default = ToolsSettingsTab;
const Tab = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 0 10px;
  padding: 0 0 2px 0;

  color: ${props => props.selected ? props.theme.text : props.theme.tools.spurs.tab};

  font-size: 12px;
  text-align: center;

  border-bottom: 3px solid
    ${props => (props.selected ? props.theme.green : 'transparent')};
`;
const TabIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 40px;
  height: 40px;

  margin: 0 auto 5px auto;
`;
const StyledPushInAnimation = (0, styled_components_1.default)(ui_1.PushInAnimation) `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
